import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Button, Form, Text, Textarea, View } from 'src/components/common';
import { Yup } from 'src/services';
import { Formik } from 'formik';
import { FORM_ERROR } from 'src/appConfig/constanst';

export type RejectModalData = {
  title?: string | React.ReactNode;
  defaultValue?: string;
  okText?: string;
  cancelText?: string;
  onCancel?: (...arg: any[]) => void;
  onOk?: (...arg: any[]) => void;
};

type Reason = {
  reason: string;
};

const RejectModal: React.FC<Props> = ({ modalData }) => {
  const {
    title,
    defaultValue,
    okText,
    cancelText,
    onOk = () => {},
    onCancel = () => {},
  } = modalData as RejectModalData;
  const initial = {
    reason: defaultValue || '',
  };
  const ReasonSchema = Yup.object().shape({
    reason: Yup.string().required(FORM_ERROR.RequiredField),
  });
  const handleOkClick = (values: Reason) => {
    onOk(values.reason);
  };
  return (
    <View className={`ctn-modal__content`}>
      {title && (
        <Text className="mb-4 ctn-modal__content__title" size={20}>
          {title}
        </Text>
      )}
      <Formik initialValues={initial} onSubmit={handleOkClick} validationSchema={ReasonSchema}>
        {({ errors, touched, handleSubmit, getFieldProps }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <Textarea
              label="Reason of rejection"
              placeholder="Reason of rejection"
              errorMessage={touched.reason ? errors.reason : ''}
              containerClassName="mb-5"
              {...getFieldProps('reason')}
            />

            <View isRow justify="flex-end">
              <Button onClick={onCancel} type="button" variant="secondary-outline" className="mr-3">
                {cancelText || 'Cancel'}
              </Button>
              <Button type="submit">{okText || 'OK'}</Button>
            </View>
          </Form>
        )}
      </Formik>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RejectModal);
